/** Shared keys/events for first-success + usefulness care prompts (Care Dock has its own keys). */

export type CareTool = "chat";

export type CareSurface = "first-success" | "usefulness" | "care-dock";

/** Unified success event: detail = { tool: CareTool } */
export const CARE_TOOL_SUCCESS_EVENT = "vortixy:care-tool-success";

export const FIRST_SUCCESS_DONE_KEY = "vortixy.care.firstSuccessDone";
export const FIRST_SUCCESS_TOOL_KEY = "vortixy.care.firstSuccessTool";

export const USEFULNESS_SUCCESS_COUNT_KEY = "vortixy.care.usefulness.successCount";
export const USEFULNESS_LAST_SHOWN_AT_KEY = "vortixy.care.usefulness.lastShownAt";
export const USEFULNESS_COOLDOWN_UNTIL_KEY = "vortixy.care.usefulness.cooldownUntil";

export const USEFULNESS_SUCCESS_THRESHOLD = 4;
export const USEFULNESS_RESHOW_AFTER_MS = 48 * 60 * 60 * 1000;
export const USEFULNESS_DISMISS_COOLDOWN_MS = 5 * 24 * 60 * 60 * 1000;
export const USEFULNESS_VOTE_COOLDOWN_MS = 10 * 24 * 60 * 60 * 1000;

/** Pre-wall quota warning starts here (existing upgrade nudge remains ≥80). */
export const QUOTA_PRE_WALL_PCT = 90;
